import React from 'react';
import './TrustBadges.css';

const TrustBadges = () => {
  const badges = [
    {
      icon: '🚚',
      title: 'Nationwide Shipping',
      description: 'Delivered across South Africa',
      link: '/shipping'
    },
    {
      icon: '⭐',
      title: 'Premium Quality',
      description: 'Authentic cultural pieces',
      link: '/quality'
    },
    {
      icon: '🛒',
      title: 'Secure Payments',
      description: 'Yoco & PayPal protected',
      link: '/payments'
    },
    {
      icon: '↩️',
      title: 'Easy Returns',
      description: '30-day return policy',
      link: '/returns'
    }
  ];

  return (
    <section className="trust-badges section">
      <div className="container">
        <div className="trust-badges__grid">
          {badges.map((badge, index) => (
            <a 
              key={index}
              href={badge.link}
              className="trust-badge"
              title={`Learn more about ${badge.title}`}
            >
              <div className="trust-badge__icon">
                {badge.icon}
              </div>
              <h4 className="trust-badge__title">{badge.title}</h4>
              <p className="trust-badge__description">{badge.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
